<div class="content-with-stepper-and-title" *ngIf="!isPostlogin">
  <vcl-alert *ngIf="notFound" class="mt-3 mb-4" [type]="'error'" [icon]="'check'" [dismissible]="false">
    {{ copyService.copies.request_consult_copies.not_found_label }}
  </vcl-alert>
  <main>
    <form id="formContactInfo" class="form row" [formGroup]="formGroup">
      <div class="col-12 col-pr-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <h1 id="backDocTitle" class="mb-4 sub-title"
          [innerHtml]="copyService.copies.request_consult_copies.subtitle_document"></h1>
      </div>
      <div class="mb-4 field col-4 col-pr-6 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <voxel-form-field [label]="copyService.copies.request_consult_copies.doc_type.label"
          [msgErr]="copyService.copies.request_consult_copies.doc_type.error">
          <vcl-autocomplete [placeholder]="copyService.copies.request_consult_copies.doc_type.placeholder"
            (change)="doc_type_change($event)" formControlName="doc_type"
            [notFoundTitle]="copyService.copies.request_consult_copies.doc_type.filter_not_found_title"
            [notFoundMessage]="copyService.copies.request_consult_copies.doc_type.filter_not_found_message">
            <vcl-option [id]="'doc_type_' + doc_type.id " *ngFor="let doc_type of select_doc_type" [value]="doc_type">
              {{ doc_type.name }}
            </vcl-option>
          </vcl-autocomplete>
        </voxel-form-field>
      </div>
      <div class="mb-4 field col-4 col-pr-6 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <vcl-form-field [label]="copyService.copies.request_consult_copies.doc_num.label"
          [msgErr]="printErrorMessage()">
          <input vclInput (input)="reactiveInputChange()" type="text"
            [placeholder]="copyService.copies.request_consult_copies.doc_num.placeholder" formControlName="doc_number">
        </vcl-form-field>
      </div>
      <div class="col-12 col-pr-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <h1 id="backDocTitle" class="mb-4 sub-title"
          [innerHtml]="copyService.copies.request_consult_copies.subtitle_request"></h1>
        <vcl-alert class="mt-3 mb-4" [type]="'warning'" [light]="'true'" [icon]="'inovacao_outline'"
          [dismissible]="false">
          {{ copyService.copies.request_consult_copies.detail_request }}
        </vcl-alert>
      </div>
      <div class="mb-4 field col-4 col-pr-6 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <vcl-form-field label="{{ copyService.copies.request_consult_copies.input_request_label }}"
          msgErr="{{ formGroup.controls.requestNumber.errors && formGroup.controls.requestNumber.errors.minlength ? copyService.copies.request_consult_copies.input_error_length : copyService.copies.request_consult_copies.input_error }}">
          <input vclInput placeholder="{{ copyService.copies.request_consult_copies.placeholder }}"
            id="inputRequestNumber" type="number" (input)="keyPressRequest($event)" formControlName="requestNumber">
        </vcl-form-field>
      </div>
    </form>
  </main>
  <app-controls id="payDayBtns" [hasPrevious]="true" [nextDisabled]="formGroup.invalid || notFound"
    [nextLabel]="copyService.copies.consult_btn" (next)="next()"></app-controls>
</div>
<div class="content-with-stepper-and-title" *ngIf="isPostlogin">
  <main>
    <div *ngIf="requests">
      <h1 id="backDocTitle" class="sub-title"
        [innerHtml]="copyService.copies.request_consult_copies.subtitle_existing_customer" *ngIf="requests.length"></h1>
      <ul class="mt-3" *ngIf="requests.length">
        <vcl-list>
          <li *ngFor="let request of requests" vclListSimple>
            <vcl-list-text (click)="nextSolicitation(request)">
              <div class="text">{{ copyService.copies.request_consult_copies.request }} {{ request.solicitation_id }}
              </div>
              <div class="sub-text">{{ copyService.copies.request_consult_copies.creation_date }} {{ request ?
                formatDate(request.solicitation_date_history.split(',')[0]) : ''}}</div>
            </vcl-list-text>
            <span id="iconCheck" class="icon icon-itaufonts_seta_right"> </span>
          </li>
        </vcl-list>
      </ul>
    </div>
  </main>
  <app-controls id="payDayBtns" [hasPrevious]="false" [nextLabel]="copyService.copies.controls_return_button.action1"
    (next)="onPrevious()"></app-controls>
</div>